import { imgixHost } from 'src/config'

export const TYPES = {
  SINGLE: 'single',
  BONUS: 'bonus',
  CUSTOM: 'custom'
}
TYPES.ALL = _.values(TYPES)
Object.freeze(TYPES)

export const createGiftCardSale = () => {
  return {
    key: crypto.getRandomValues(new Uint32Array(1))[0],
    name: 'Gift Card',
    type: TYPES.SINGLE,
    class: null,
    amount: 10,
    bonusAmount: 10,
    image: null,
    color: null,
    custom: false,
    customMinimumAmount: 10,
    customMaximumAmount: 1000
  }
}

export function giftCardSaleImageUrl (imageKey, color, { width = 600, height = 400 } = {}) {
  if (_.isEmpty(imageKey)) return null

  return `${imgixHost}/${imageKey}?fit=crop&w=${width}&h=${height}&fill=solid&fill-color=${color}&bg=${color}&fm=jpeg&auto=format,compress`
}
